import { Provider } from '@angular/core';

import { VacationsRepositoryImpl } from '@app/data/repositories/mot/vacations/vacations.repository';
import { VACATIONS_REPOSITORY } from '@app/domain/repositories/mot/vacations.repository.contract';

export const vacationsRepositoryProvider: Provider = {
  provide: VACATIONS_REPOSITORY,
  useClass: VacationsRepositoryImpl
};
